import { queryOptions } from '@tanstack/react-query';
import { maxNetworksQueryOptions } from '#api/networks.queries.ts';
import { truncateAddress } from '#components/atoms/pill/ip-address-pill/truncateAddress.ts';
import type { Network } from '#dn-types/network.ts';
import { getCidrV4, getCidrV6 } from '#util/networkCidrs.ts';

/**
 * Fetches a list of every network in the account, 500 at a time, up to 5000 networks.
 */
export function makeAllNetworksQueryOptions(filterNetworks: (network: Network) => boolean = () => true) {
  return queryOptions({
    ...maxNetworksQueryOptions,
    select: (data) => {
      const networkItems = data.data
        .filter((element) => filterNetworks(element))
        .map((network) => {
          // Join CIDRs as a comma separated shortened list (v6 first to match list display)
          const hint = [getCidrV6(network), getCidrV4(network)]
            .filter(Boolean)
            .map((ip) => truncateAddress(ip))
            .join(', ');
          return { value: network.id, label: network.name, hint };
        });

      return { items: networkItems };
    },
  });
}
